
export const CHF_CURRENCY = 'CHF';
export const EUR_CURRENCY = 'EUR';
export const USD_CURRENCY = 'USD';

export const currencies = [CHF_CURRENCY, EUR_CURRENCY, USD_CURRENCY];

export type Currency =
   typeof CHF_CURRENCY |
   typeof EUR_CURRENCY |
   typeof USD_CURRENCY;